import Member from 'iam/models/Member'
import TermsOfUseStore from 'iam/TermsOfUseStore'
import { getFeatureToggleClient } from 'infra/featureToggles'
import ModalViewModel from 'infra/ModalViewModel'
import { action, computed, makeObservable, observable } from 'mobx'
import { Observable } from 'rxjs'
import { Id, Nullable } from 'types/definitions'

export type EnsureTermsAccepted = (workspaceId: Nullable<Id>) => Promise<void>

export default class TermsModalViewModel extends ModalViewModel {
  @observable
  termsContent = ''

  @observable currentWorkspaceId?: Nullable<string> = null

  constructor(
    private termsStore: TermsOfUseStore,
    currentMember$: Observable<Member>
  ) {
    super()
    makeObservable(this)

    // Checks the terms of use anytime the current workspace membership changes.
    currentMember$.subscribe(async (m) => {
      if (
        m.workspace.features.tos.hideOnWortal ||
        !m.workspace.features.tos.showOnLogin
      ) {
        return
      }

      const id = m.workspace.features.tos.customTermsEnabled
        ? m.workspace.id
        : null

      await this.ensureTermsAccepted(id)
    })
  }

  @computed
  get isNewTermsEnabled() {
    return getFeatureToggleClient().variation('Portals.UseNewTerms')
  }

  @action
  async ensureTermsAccepted(workspaceId: Nullable<Id>) {
    if (!this.isNewTermsEnabled) {
      return
    }

    this.currentWorkspaceId = workspaceId
    this.termsContent = (
      await this.termsStore.fetchLatestTerms(this.currentWorkspaceId)
    ).markup

    const accepted = await this.termsStore.checkTermsOfUseAcceptance(
      this.currentWorkspaceId
    )

    if (!accepted) {
      this.show()
    }
  }

  @action
  async accept() {
    await this.termsStore
      .acceptLatestTerms(this.currentWorkspaceId)
      .then(() => this.close())
  }
}
